:host {
  box-sizing: content-box;
  contain: strict;
  display: inline-block;
  height: 1em;
  width: 1em;
}

.icon-inner,
svg {
  display: block;
  height: 100%;
  width: 100%;
}

/* Icon Sizes
 * -----------------------------------------------------------
 * 'tiny' | 'small' | 'medium' | 'large';
 */

:host(.icon-tiny) {
  font-size: 16px !important;
}

:host(.icon-small) {
  font-size: 24px !important;
}

:host(.icon-medium) {
  font-size: 32px !important;
}

:host(.icon-large) {
  font-size: 48px !important;
}
